<template>
    <mdc-dialog v-model="isOpen"
                :title="'rotation.report.header' | trans"
                :accept="'rotation.save' | trans"
                :cancel="'rotation.cancel' | trans"
                :accept-disabled="disabled"
                @validate="save"
                @accept="close"
                @close="close"
                @cancel="cancel"
                :class="{'fullscreen-dialog' : isMobile}">
        <div v-if="!isMobile">

            <div class="close-cross" @click="cancel()">
                <mdc-icon icon="close"></mdc-icon>
            </div>

            <div class="row">
                <div class="col">
                    <p class="gray-dark-sm">{{'rotation.report.date' | trans}}:</p>
                    <p class="gray-700">{{date}}</p>
                </div>
                <div class="col">
                    <p class="gray-dark-sm">{{'rotation.report.client' | trans}}:</p>
                    <p class="gray-700">{{assignee.code}}</p>
                </div>
                <div class="col">
                    <p class="gray-dark-sm">{{auditor.role}}</p>
                    <p class="gray-700">{{auditor.name}}</p>
                </div>
            </div>
            <div class="row">
                <table class="table table-sm" v-if="!isMobile">
                    <thead class="thead-light">
                    <tr>
                        <th>{{'rotation.report.successful_answer_rate' | trans}}</th>
                        <th>{{'rotation.report.hint_rate' | trans}}</th>
                        <th>{{'rotation.report.fail_answer_rate' | trans}}</th>
                        <th>{{'rotation.report.no_answer_rate' | trans}}</th>
                        <th>{{'rotation.report.all_approaches_count' | trans}}</th>
                    </tr>
                    </thead>
                    <tbody class="gray-700 text-center">
                    <tr>
                        <td>{{successfulAnswerRate | percent}}</td>
                        <td>{{hintRate | percent}}</td>
                        <td>{{failAnswerRate | percent}}</td>
                        <td>{{noAnswerRate | percent}}</td>
                        <td>{{allApproachesCount}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else>
            <mdc-toolbar slot="toolbar"
                         class="navbar-expand-lg navbar-custom  navbar-dark bg-primary mb-0 mb-md-4">
                <div class="container">
                    <!--  toolbar markup here -->
                    <mdc-toolbar-row>
                        <mdc-toolbar-section shrink-to-fit>
                            <span @click="cancel">
                                <mdc-icon icon="close"></mdc-icon>
                            </span>
                            <h3 class="title">{{'rotation.report.report' | trans}}</h3>
                        </mdc-toolbar-section>
                        <mdc-toolbar-section align-end>
                            <button class="btn btn-link" @click.prevent="save">{{'dro.back_to_reports' | trans}}</button>
                        </mdc-toolbar-section>
                    </mdc-toolbar-row>
                </div>
            </mdc-toolbar>

            <div class="mobile-table">
                <div class="mobile-table__body">
                    <div class="mobile-table__row mx-0">
                        <div class="description pt-2">
                            <div>
                                <p class="gray-dark head">{{'rotation.report.successful_answer_rate' | trans}}</p>
                                <p class="p-2 gray-700">{{successfulAnswerRate | percent}}</p>
                            </div>

                            <div>
                                <p class="gray-dark head">{{'rotation.report.hint_rate' | trans}}</p>
                                <p class="p-2 gray-700">{{hintRate | percent}}</p>
                            </div>

                            <div>
                                <p class="gray-dark head">{{'rotation.report.fail_answer_rate' | trans}}</p>
                                <p class="p-2 gray-700">{{failAnswerRate | percent}}</p>
                            </div>

                            <div>
                                <p class="gray-dark head">{{'rotation.report.no_answer_rate' | trans}}</p>
                                <p class="p-2 gray-700">{{noAnswerRate | percent}}</p>
                            </div>

                            <div>
                                <p class="gray-dark head">{{'rotation.report.all_approaches_count' | trans}}</p>
                                <p class="p-2 gray-700">{{allApproachesCount}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mdc-dialog>
</template>

<script>
  import {mapActions, mapGetters, mapState} from 'vuex';
  import Manager from '../api/Manager';
  import Constants from '../Constants';

  export default {
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    data() {
      return {
        disabled: false,
        allApproachesCount: 0,
        approachesCheckedCount: 0,
        failAnswerCount: 0,
        successfulCount: 0,
        hintCount: 0,
      };
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        },
      },
      ...mapState('rotation/session', [
        'auditor',
        'assignee',
        'settings',
        'sessions',
        'stimuli',
        'startedAt',
        'finishedAt',
        'uuid',
      ]),
      ...mapState(['route']),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      date() {
        let date = new Date();
        let day = date.getDate();
        if (day < 10) {
          day = `0${day}`;
        }
        let month = date.getMonth() + 1;
        if (month < 10) {
          month = `0${month}`;
        }
        return `${day}.${month}.${date.getFullYear()}`;
      },
      hintRate() {
        return Math.round((this.hintCount / this.allApproachesCount) * 100) || 0;
      },
      successfulAnswerRate() {
        return Math.round((this.successfulCount / this.allApproachesCount) * 100) || 0;
      },
      failAnswerRate() {
        return Math.round((this.failAnswerCount / this.allApproachesCount) * 100) || 0;
      },
      noAnswerRate() {
        return Math.round(100 - (this.approachesCheckedCount / this.allApproachesCount) * 100) || 0;
      },
    },
    created() {
      this.countAll();
    },
    methods: {
      ...mapActions('rotation/session', [
        'setFinishedAt',
        'setIsSaved',
      ]),
      countAll() {
        this.allApproachesCount = 0;
        this.approachesCheckedCount = 0;
        this.failAnswerCount = 0;
        this.successfulCount = 0;
        this.hintCount = 0;

        for (let i = 0; i < Object.keys(this.sessions).length; i++) {
          for (let j = 0; j < this.sessions[i].blocks.length; j++) {
            if (this.sessions[i].blocks[j].resultId === Constants.SUCCESSFUL_ANSWER) {
              this.successfulCount++;
              this.approachesCheckedCount++;
            }
            else if (this.sessions[i].blocks[j].resultId === Constants.FAIL_ANSWER) {
              this.failAnswerCount++;
              this.approachesCheckedCount++;
            }
            else if (this.sessions[i].blocks[j].resultId === Constants.HINT_ANSWER) {
              this.hintCount++;
              this.approachesCheckedCount++;
            }
            this.allApproachesCount++;
          }
        }
      },
      cancel() {
        this.$emit('cancel');
      },
      close() {
        this.$emit('close');
      },
      async save({accept}) {
        try {
          this.setFinishedAt(Math.round((new Date()).getTime() / 1000));
          this.disabled = true;
          let data = {
            assigneeId: this.route.params.clientId,
            uuid: this.uuid,
            startedAt: this.startedAt,
            finishedAt: this.finishedAt,
            stimuli: this.stimuli,
            sessions: this.sessions,
            report: {
              totalCount: this.allApproachesCount,
              rightCount: this.successfulCount,
              wrongCount: this.failAnswerCount,
              suggestedCount: this.hintCount,
              uncompletedCount: (this.allApproachesCount - this.approachesCheckedCount),
            },
          };
          let {data: response} = await
              Manager.save(data);
          if (response && response.data && response.data.id) {
            if (accept) {
              accept();
            }
            this.close();
          } else {
            throw new Error('Unknown API error');
          }
        } catch (e) {
          console.error(e);
        } finally {
          this.disabled = false;
        }
      },
    },
    watch: {
      sessions: function() {
        this.countAll();
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/randomRotation/components/ReportModal.vue